export const update = {
  form: {
    name: 'Name',
    totalTimeUsed: 'Total Time Used',
    totalLife: 'Total Life',
    submit: 'Submit',
    timeUnit: 'Mins',
    addMoreMachineComponent: 'Add More Machine Component',
    requireServiceLife: 'Please input machine component service life',
    requireTotalTimeUsed: 'Please input machine component total time used',
    requireName: 'Please input machine component name',
    update: 'Update',
    cancel: 'Cancel',
    invalidNumbers: 'Only numbers are allowed.',
  },
  pageHeader: {
    title: 'Update Machine Component',
    back: 'Back',
  },
}
